// extracted by mini-css-extract-plugin
module.exports = {"Splash":"Splash_Splash__2igZt","fade":"Splash_fade__5FrZT"};